import { useState } from "react";
import AdminTemplateRequestsPage from "./AdminTemplateRequestsPage";
import AdminSupportRequestsPage from "./AdminSupportRequestsPage";

/**
 * AdminUserRequestsPage — single page that combines Template Requests and
 * Support Requests behind a tab switcher. We embed the existing pages
 * verbatim instead of merging their innards because both have distinct
 * data shapes (template uploads vs. text messages) and rewriting them
 * into one would just balloon the file.
 */
export default function AdminUserRequestsPage() {
  const [tab, setTab] = useState("templates");

  return (
    <div data-testid="admin-user-requests-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 tracking-tight">User Requests</h1>
          <p className="text-sm text-gray-500 mt-1">
            Review template uploads and reply to support questions in one place.
          </p>
        </div>
        <div className="mt-5 flex items-center gap-2 border-b border-gray-200">
          <TabButton active={tab === "templates"} onClick={() => setTab("templates")} testId="ur-tab-templates">
            Template Requests
          </TabButton>
          <TabButton active={tab === "support"} onClick={() => setTab("support")} testId="ur-tab-support">
            Support Requests
          </TabButton>
        </div>
      </div>
      {tab === "templates" ? <AdminTemplateRequestsPage embedded /> : <AdminSupportRequestsPage embedded />}
    </div>
  );
}

const TabButton = ({ active, onClick, testId, children }) => (
  <button
    onClick={onClick}
    data-testid={testId}
    className={`px-4 py-2 text-sm font-medium transition-colors -mb-px border-b-2 ${
      active
        ? "border-teal-600 text-teal-700"
        : "border-transparent text-gray-500 hover:text-gray-800"
    }`}
  >
    {children}
  </button>
);
